var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('TxTableHead'), _vm.transactions.length === 0 ? _c('v-alert', {
    attrs: {
      "color": "#e6f5ff",
      "dense": ""
    }
  }, [_vm._v(" There are no matching entries ")]) : _vm._e(), _c('div', {
    staticClass: "rows"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, _vm._l(_vm.transactions, function (tx) {
    return _c('TxRow', {
      key: tx.id,
      staticClass: "tx_item",
      attrs: {
        "transaction": tx
      }
    });
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }